/**
 * The Settings routes (Quick 261013-srg PR 1). Called as a function inside App.tsx's <Routes> —
 * React Router reads <Route> elements through fragments — so the route test renders exactly the
 * table the app uses.
 */
import * as React from 'react';
import { Navigate, Route } from 'react-router-dom';
import { SettingsPage } from '../../routes/SettingsPage';
import { ImportPage } from '../../routes/ImportPage';

export function settingsRoutes(): React.JSX.Element {
  return (
    <>
      {/* Setup & Configuration is now Settings → Getting started. */}
      <Route path="/setup-config" element={<Navigate to="/settings/getting-started" replace />} />
      <Route path="/settings" element={<SettingsPage />} />
      {/* The static /settings/import outranks /settings/:section in React Router. */}
      <Route path="/settings/import" element={<ImportPage />} />
      <Route path="/settings/:section" element={<SettingsPage />} />
    </>
  );
}
